import {
  ByDateCard,
  ByDateCardVariantEnum,
} from '@app/feature/statistics/components/by-date-card/by-date.card';
import { useCpmsBoGetEnergyDeliveredByDayQuery } from '@service/cpms-bo-transaction-reports-energy-statistics.service';

import { useFilters } from '../../context/filters.context';

export const EnergyByDayCard = (): React.JSX.Element => {
  const { transformedFilters } = useFilters();
  const { data } = useCpmsBoGetEnergyDeliveredByDayQuery({
    ...transformedFilters,
  });

  return <ByDateCard data={data} variant={ByDateCardVariantEnum.Energy} />;
};
